import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	title: {
		fontSize: 18,
		fontWeight: 400,
		color: colors.gray[600]
	},
	contactsWithoutExchangingMessagesIcon: {
		width: 14,
		height: 14
	}
}))

export default useStyles
